import React from 'react';
import { ActivityRangeMenu, ActivityCustomRangeMenu, ActivityComparisonMenu } from './container-activity-menus';
import { MDCAnchorMenu, MDCMenu } from "../../jsx/components/mdc-components";
import compRange from '../functions/comp-range';
export class ActivityContainer extends React.Component {
  render() {
    var cls = 'container';
    if (this.props.cls) {
      cls += ' ' + this.props.cls;
    }
    return /*#__PURE__*/React.createElement("section", {
      className: cls
    }, this.props.children);
  }
}
export class ActivityHeader extends React.Component {
  render() {
    var title = this.props.title;
    if (!title) title = 'Activity';
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "header"
    }, /*#__PURE__*/React.createElement("div", null, title), /*#__PURE__*/React.createElement("div", null, this.props.custom ? /*#__PURE__*/React.createElement(ActivityCustomRangeMenu, {
      id: this.props.id,
      onSelected: this.props.onSelected,
      selection: this.props.selection
    }, this.props.children) : /*#__PURE__*/React.createElement(ActivityRangeMenu, {
      id: this.props.id,
      onSelected: this.props.onSelected,
      selection: this.props.selection
    }))), /*#__PURE__*/React.createElement("hr", null));
  }
}
class ComparisonRangeLabel extends React.Component {
  render() {
    var display = true;
    var result = compRange(this.props.range, this.props.comp);
    if (!result.range) display = false;
    return /*#__PURE__*/React.createElement("div", {
      className: "comparison-range-label"
    }, display && /*#__PURE__*/React.createElement("div", {
      className: "flex-box"
    }, /*#__PURE__*/React.createElement("span", {
      className: "range-text"
    }, result.range), /*#__PURE__*/React.createElement("span", {
      className: "vs"
    }, "vs."), /*#__PURE__*/React.createElement("span", {
      className: "comp-text"
    }, result.comp)));
  }
}
export class ActivityTrendsHeader extends React.Component {
  render() {
    var title = this.props.title;
    if (!title) title = 'Activity';
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "header"
    }, /*#__PURE__*/React.createElement("div", null, title), !this.props.hideControls && /*#__PURE__*/React.createElement("div", {
      className: "range-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "dl-label"
    }, "Trend Comparison:"), /*#__PURE__*/React.createElement(ActivityComparisonMenu, {
      id: this.props.compId,
      onSelected: this.props.onCompSelected,
      selection: this.props.compSelection,
      hide: this.props.compHide
    }), /*#__PURE__*/React.createElement("div", {
      className: "dl-label"
    }, "Range:"), /*#__PURE__*/React.createElement(ActivityRangeMenu, {
      id: this.props.id,
      onSelected: this.props.onSelected,
      selection: this.props.selection
    }))), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(ComparisonRangeLabel, {
      range: this.props.range,
      comp: this.props.comp
    }));
  }
}
export class ActivityHeaderNoDropDown extends React.Component {
  render() {
    var title = this.props.title;
    if (!title) title = 'Activity';
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "header"
    }, /*#__PURE__*/React.createElement("div", null, title), /*#__PURE__*/React.createElement("div", null)), /*#__PURE__*/React.createElement("hr", null));
  }
}
export class ActivityData extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "activity"
    }, this.props.children);
  }
}
export class DetailContainer extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {}
  render() {
    var cls = '';
    if (this.props.cls) cls = this.props.cls;
    var mainCls = '';
    if (this.props.mainCls) {
      mainCls = this.props.mainCls;
    }
    return /*#__PURE__*/React.createElement(ActivityContainer, {
      cls: mainCls
    }, /*#__PURE__*/React.createElement("div", {
      className: "header"
    }, /*#__PURE__*/React.createElement("div", null, this.props.title), /*#__PURE__*/React.createElement("div", {
      className: cls
    }, /*#__PURE__*/React.createElement("div", {
      className: "arrow-back",
      onClick: this.props.onGoBack
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons arrow-back"
    }, "arrow_back"), /*#__PURE__*/React.createElement("span", {
      className: "small-link"
    }, " BACK")))), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(ActivityData, null, this.props.children));
  }
}
export class ActivityDetailContainer extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {}
  render() {
    return /*#__PURE__*/React.createElement(ActivityContainer, null, /*#__PURE__*/React.createElement("div", {
      className: "header"
    }, /*#__PURE__*/React.createElement("div", null, this.props.title), /*#__PURE__*/React.createElement("div", {
      className: "flex-box align-center"
    }, this.props.hidePicker ? null : this.props.custom ? /*#__PURE__*/React.createElement(MDCAnchorMenu, {
      menuId: this.props.id,
      onMenuSelected: this.props.onSelected,
      cls: "small-list-item-size"
    }, /*#__PURE__*/React.createElement("button", {
      className: "anchor-menu-button",
      "data-anchor": true
    }, this.props.selection, " ", /*#__PURE__*/React.createElement("i", {
      className: "material-icons"
    }, "arrow_drop_down")), /*#__PURE__*/React.createElement(MDCMenu, {
      disableInit: "true",
      id: this.props.id
    }, this.props.children)) : /*#__PURE__*/React.createElement(MDCAnchorMenu, {
      menuId: this.props.id,
      onMenuSelected: this.props.onSelected,
      cls: "small-list-item-size"
    }, /*#__PURE__*/React.createElement("button", {
      className: "anchor-menu-button",
      "data-anchor": true
    }, this.props.selection, " ", /*#__PURE__*/React.createElement("i", {
      className: "material-icons"
    }, "arrow_drop_down")), /*#__PURE__*/React.createElement(MDCMenu, {
      disableInit: "true",
      id: this.props.id
    }, /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "today",
      "data-id": "today"
    }, "Today"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "yesterday",
      "data-id": "yesterday"
    }, "Yesterday"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "this_week",
      "data-id": "this_week"
    }, "This Week"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "last_week",
      "data-id": "last_week"
    }, "Last Week"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "this_month",
      "data-id": "this_month"
    }, "This Month"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "last_month",
      "data-id": "last_month"
    }, "Last Month"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "this_quarter",
      "data-id": "this_quarter"
    }, "This Quarter"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "last_quarter",
      "data-id": "last_quarter"
    }, "Last Quarter"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "this_year",
      "data-id": "today"
    }, "This Year"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "last_year",
      "data-id": "today"
    }, "Last Year"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "all_time",
      "data-id": "all_time"
    }, "All Time"), this.props.reset && /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "reset",
      "data-id": "reset"
    }, "Reset"))), /*#__PURE__*/React.createElement("div", {
      className: "arrow-back left-margin",
      onClick: this.props.onGoBack
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons arrow-back"
    }, "arrow_back"), /*#__PURE__*/React.createElement("span", {
      className: "small-link"
    }, " BACK")))), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(ActivityData, null, this.props.children));
  }
}
export class ActivityFilter extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {}
  render() {
    return /*#__PURE__*/React.createElement(MDCAnchorMenu, {
      menuId: this.props.id,
      onMenuSelected: this.props.onSelected,
      cls: "small-list-item-size"
    }, /*#__PURE__*/React.createElement("button", {
      className: "anchor-menu-button",
      "data-anchor": true
    }, this.props.selection, " ", /*#__PURE__*/React.createElement("i", {
      className: "material-icons"
    }, "arrow_drop_down")), /*#__PURE__*/React.createElement(MDCMenu, {
      disableInit: "true",
      id: this.props.id
    }, /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "All",
      "data-id": "All"
    }, "All"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "Conversion",
      "data-id": "Type"
    }, "Conversion"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "Engagement",
      "data-id": "Type"
    }, "Engagement"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "Value",
      "data-id": "Value"
    }, "Has Value"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "Campaign",
      "data-id": "Campaign"
    }, "Is Campaign"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "Source",
      "data-id": "Source"
    }, "Is Source")));
  }
}
export default {
  ActivityContainer,
  ActivityHeader,
  ActivityTrendsHeader,
  ActivityHeaderNoDropDown,
  ActivityData,
  DetailContainer,
  ActivityDetailContainer,
  ActivityFilter
};